// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_box {
  height: 95px;
  width: 95px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.sidebar_box .new-tag {
  position: absolute;
  top: 4px;
  right: 4px;
  border-radius: 15px;
  background-color: #e9e9f2;
  font-size: 0.5rem;
  padding: 0px 2px;
  line-height: 10px;
  color: #5b5fc7;
}

.new-menu-active {
  border: 3px solid;
  border-radius: 5px;
  border-image-slice: 1;
  border-image-source: linear-gradient(27.54deg, #532f91 -28.21%, rgba(117, 82, 203, 0.94) 42.29%, #01a4e7 118.51%);
}

.padding-in-grid {
  margin: 0 0.625rem 0.625rem 0;
}

.sidebar_box:hover {
  background: linear-gradient(27.54deg, #532f91 -28.21%, rgba(117, 82, 203, 0.94) 42.29%, #01a4e7 118.51%);
  color: white;
}

.active {
  background: linear-gradient(27.54deg, #532f91 -28.21%, rgba(117, 82, 203, 0.94) 42.29%, #01a4e7 118.51%) !important;
  color: white !important;
}
.active svg {
  color: white !important;
  fill: white !important;
}

.sidebar_box:hover svg {
  color: white !important;
  fill: white !important;
}

.sidebar-root {
  display: flex;
  position: relative;
  height: 100%;
  min-height: 100vh;
}
.sidebar-root .sidebar-main {
  min-height: 100vh;
  padding: 2px;
}

.content {
  position: relative;
  flex-grow: 1;
  height: 100vh;
  padding: 0.8rem;
  overflow: auto;
}

.sidebar_child_option {
  background: linear-gradient(27.54deg, #532f91 -28.21%, rgba(117, 82, 203, 0.94) 42.29%, #01a4e7 118.51%);
}

.sidebar-subMenu {
  width: 235px;
  height: 40px;
  background: linear-gradient(27.54deg, #532f91 -28.21%, rgba(117, 82, 203, 0.94) 42.29%, #01a4e7 118.51%);
  box-sizing: border-box;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  cursor: pointer;
}
.sidebar-subMenu svg {
  color: white;
  fill: white;
}
.sidebar-subMenu:hover {
  border: 0.5px solid #ffffff;
  background: linear-gradient(229.15deg, #532f91 -13.33%, rgba(117, 82, 203, 0.94) 41.89%, #01a4e7 101.6%);
}

.sidebar-subMenu-active {
  border: 2px solid #ffffff;
}

.sidebar-mobile {
  position: fixed;
  bottom: -0.6rem;
  right: 0;
  left: 0;
  background: transparent;
  z-index: 100;
}
.sidebar-mobile .sidebar_box {
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.sidebar-mobile .sidebar_box svg {
  width: 25px;
  height: 25px;
}
.sidebar-mobile .sidebar-main {
  padding: 2px;
  overflow: overlay;
}
.sidebar-mobile .content {
  flex-grow: 1;
  height: calc(100vh - 75px);
  padding: 0rem;
  overflow: overlay;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iHAAA;AAAF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,wGAAA;EAIA,YAAA;AANF;;AASA;EACE,mHAAA;EAIA,uBAAA;AATF;AAWE;EACE,uBAAA;EACA,sBAAA;AATJ;;AAaA;EACE,uBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAVF;AAYE;EAEE,iBAAA;EACA,YAAA;AAXJ;;AAeA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EAIA,eAAA;EACA,cAAA;AAfF;;AAkBA;EACE,wGAAA;AAfF;;AAqBA;EACE,YAAA;EACA,YAAA;EACA,wGAAA;EAIA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AArBF;AAuBE;EACE,YAAA;EACA,WAAA;AArBJ;AAwBE;EACE,2BAAA;EACA,wGAAA;AAtBJ;;AA6BA;EACE,yBAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;AA1BF;AA4BE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA1BJ;AA4BI;EACE,WAAA;EACA,YAAA;AA1BN;AA8BE;EAEE,YAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,YAAA;EACA,0BAAA;EAEA,aAAA;EACA,iBAAA;AA/BJ","sourcesContent":[".sidebar_box {\n  height: 95px;\n  width: 95px;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n\n  .new-tag {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    border-radius: 15px;\n    background-color: #e9e9f2;\n    font-size: 0.5rem;\n    padding: 0px 2px;\n    line-height: 10px;\n    color: #5b5fc7;\n  }\n}\n\n.new-menu-active {\n  border: 3px solid;\n  border-radius: 5px;\n  border-image-slice: 1;\n  border-image-source: linear-gradient(27.54deg,\n      #532f91 -28.21%,\n      rgba(117, 82, 203, 0.94) 42.29%,\n      #01a4e7 118.51%);\n}\n\n.padding-in-grid {\n  margin: 0 0.625rem 0.625rem 0;\n}\n\n.sidebar_box:hover {\n  background: linear-gradient(27.54deg,\n      #532f91 -28.21%,\n      rgba(117, 82, 203, 0.94) 42.29%,\n      #01a4e7 118.51%);\n  color: white;\n}\n\n.active {\n  background: linear-gradient(27.54deg,\n      #532f91 -28.21%,\n      rgba(117, 82, 203, 0.94) 42.29%,\n      #01a4e7 118.51%) !important;\n  color: white !important;\n\n  svg {\n    color: white !important;\n    fill: white !important;\n  }\n}\n\n.sidebar_box:hover svg {\n  color: white !important;\n  fill: white !important;\n}\n\n.sidebar-root {\n  display: flex;\n  position: relative;\n  height: 100%;\n  min-height: 100vh;\n\n  .sidebar-main {\n    // background: white;\n    min-height: 100vh;\n    padding: 2px;\n  }\n}\n\n.content {\n  position: relative;\n  flex-grow: 1;\n  height: 100vh;\n  // max-height: 100vh;\n  //  min-height: 100vh;\n  // background: #f5f5f5;\n  padding: 0.8rem;\n  overflow: auto;\n}\n\n.sidebar_child_option {\n  background: linear-gradient(27.54deg,\n      #532f91 -28.21%,\n      rgba(117, 82, 203, 0.94) 42.29%,\n      #01a4e7 118.51%);\n}\n\n.sidebar-subMenu {\n  width: 235px;\n  height: 40px;\n  background: linear-gradient(27.54deg,\n      #532f91 -28.21%,\n      rgba(117, 82, 203, 0.94) 42.29%,\n      #01a4e7 118.51%);\n  box-sizing: border-box;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  cursor: pointer;\n\n  svg {\n    color: white;\n    fill: white;\n  }\n\n  &:hover {\n    border: 0.5px solid #ffffff;\n    background: linear-gradient(229.15deg,\n        #532f91 -13.33%,\n        rgba(117, 82, 203, 0.94) 41.89%,\n        #01a4e7 101.6%);\n  }\n}\n\n.sidebar-subMenu-active {\n  border: 2px solid #ffffff;\n}\n\n.sidebar-mobile {\n  position: fixed;\n  bottom: -0.6rem;\n  right: 0;\n  left: 0;\n  background: transparent;\n  z-index: 100;\n\n  .sidebar_box {\n    height: 80px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    svg {\n      width: 25px;\n      height: 25px;\n    }\n  }\n\n  .sidebar-main {\n    // background: white;\n    padding: 2px;\n    overflow: overlay;\n  }\n\n  .content {\n    flex-grow: 1;\n    height: calc(100vh - 75px);\n    // background-color: #f5f5f5;\n    padding: 0rem;\n    overflow: overlay;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
